'use client';

import { cn } from '@coas/ui/lib';
import type { SexSchema } from '@coas/validators/const';
import { useAtom } from 'jotai';
import { sidebarStateAtom } from '../model/state';

type SexLinkProps = React.PropsWithChildren & {
    sex: SexSchema;
};

export const SexLink = ({ children, sex }: SexLinkProps) => {
    const [state, setState] = useAtom(sidebarStateAtom);

    return (
        <button
            type='button'
            className={cn(
                'flex-1 border-b-2.5 py-2.5 text-center font-600 uppercase',
                state.sex === sex ? 'border-neutral-700 text-neutral-950' : 'border-neutral-300 text-neutral-500',
            )}
            onClick={() => setState(prev => ({ ...prev, sex }))}
        >
            {children}
        </button>
    );
};
